// extracted by mini-css-extract-plugin
var _1 = "urfcm";
export { _1 as "textWrapper" }
